import styled from 'styled-components';

export default styled.h3`
  margin-bottom: 0;
  font-size: 1.75rem;
  font-weight: bold;
  text-align: center;
`;
